module.exports = __webpack_public_path__ + "static/media/four-horn-sculpin.6c899c33.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/four-horn-sculpin.png
// module id = 312
// module chunks = 0